export default "__VITE_ASSET__CHFs1Gq1__"